import {EntityData, field, NumberUtils} from "@fedeltapointofsale/data-client";

export enum Markup_Type {
    NONE = 0,
    FIXED_MARKUP = 1,
    PERCENT_MARKUP,
    FIXED_MARKDOWN,
    PERCENT_MARKDOWN,
    OVERRIDE,
    RATE,
    OPEN_FIXED_MARKDOWN,
    OPEN_PERCENT_MARKDOWN
}

export enum Limit_Type {
    MINIMUM = 1,
    MAXIMUM
}

export enum Markup_Value_Type {
    NONE,
    CURRENCY,
    PERCENT
}

export class MarkupData extends EntityData<MarkupData> {
    @field type: Markup_Type;
    @field value: number;
    @field roundingApplied: boolean = false;
    @field limitType: number;
    @field limit: number;

    public static getValueType(markupType: Markup_Type): Markup_Value_Type {
        return (markupType === Markup_Type.PERCENT_MARKUP || markupType === Markup_Type.PERCENT_MARKDOWN) ? Markup_Value_Type.PERCENT :
            (markupType === Markup_Type.FIXED_MARKUP || markupType === Markup_Type.FIXED_MARKDOWN || markupType === Markup_Type.OVERRIDE) ? Markup_Value_Type.CURRENCY :
                Markup_Value_Type.NONE;
    }

    public getPrice(base: number): number {
        switch (this.type) {
            case Markup_Type.OVERRIDE: {
                return this.value;
            }
            case Markup_Type.PERCENT_MARKUP: {
                return NumberUtils.roundValue(base + (base * this.value / 100), 2);
            }
            case Markup_Type.PERCENT_MARKDOWN: {
                return NumberUtils.roundValue(base - (base * this.value / 100), 2);
            }
            case Markup_Type.FIXED_MARKUP: {
                return NumberUtils.roundValue(base + this.value, 2);
            }
            case Markup_Type.FIXED_MARKDOWN: {
                return NumberUtils.roundValue(base - this.value, 2);
            }
            default: {
                return base;
            }
        }
    }

    public getValueType(): Markup_Value_Type {
        return MarkupData.getValueType(this.type);
    }
}
